import { createContext, useContext, useState, useEffect } from "react";
import api from "@/lib/api";

const CurrencyContext = createContext();

const SYMBOLS = { USD: "$", EUR: "\u20AC", XCD: "EC$" };

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState("USD");
  const [rates, setRates] = useState({ USD: 1, EUR: 0.92, XCD: 2.70 });

  useEffect(() => {
    api.get("/exchange-rates").then(res => setRates(res.data)).catch(() => {});
  }, []);

  const formatPrice = (usdAmount) => {
    if (!usdAmount && usdAmount !== 0) return "";
    const converted = usdAmount * (rates[currency] || 1);
    return `${SYMBOLS[currency] || "$"}${converted.toFixed(2)}`;
  };

  const symbol = SYMBOLS[currency] || "$";

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, formatPrice, rates, symbol }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);
